import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import Icon from "@mui/material/Icon"
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import MDButton from "components/MDButton";
import "./Edit_PeelingModal.css";
import { ArrowDropDown } from "@mui/icons-material";
import Checkbox from "@mui/material/Checkbox";
import { getCorporateClients, getCourierMode, getPackageType, getBox, getProducts } from "network/service";
import { toast_msessages } from "layouts/common/Messages"
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import Autocomplete from '@mui/material/Autocomplete';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';


function EditDBModal(props) {


  console.log(props.details)

  const [fromName, setFromName] = useState(props.details.from["name"]);
  const [receiverName, setreceiverName] = useState(props.details.to["name"]);
  const [fromAddress, setFromAddress] = useState(props.details.from["address"]);
  const [receiverAddress, setreceiverAddress] = useState(props.details.to["address"]);
  const [fromNumber, setFromNumber] = useState(props.details.from["phone"]);
  const [receiverNumber, setreceiverNumber] = useState(props.details.to["phone"]);
  const [fromEmail, setFromEmail] = useState(props.details.from["email"]);
  const [receiverEmail, setreceiverEmail] = useState(props.details.to["email"]);
  const [customerType, setCustomerType] = React.useState('');
  const [client, setClient] = React.useState(props["details"]["corporate_client"] ? props["details"]["corporate_client"]["_id"] : "");
  const [mode, setMode] = React.useState(props["details"]["carrier"]["_id"]);
  const [parcelType, setParcelType] = React.useState(props["details"]["package_type"]["_id"]);
  const [totalWeight, setTotalWeight] = useState(props.details.total_weight);
  const [courierAmount, setCourierAmount] = useState(props.details.courier_amount);
  const [otherAmount, setOtherAmount] = React.useState(props.details.other_amount);
  const [totalAmount, setTotalAmount] = React.useState(props.details.total_amount);
  const [paymentMode, setPaymentMode] = React.useState('');
  const [managedBy, setManagedBy] = React.useState(props.details.managed_by);
  const [note, setNote] = React.useState(props.details.notes);
  const [status, setStatus] = React.useState('');
  const [trackingNumber, setTrackingNumber] = React.useState(props.details.tracking_number);
  const [reason, setReason] = React.useState(props.details.reason);
  const [corporateList, setCorporateList] = useState([]);
  const [couriermodeList, setCourierModeList] = useState([]);
  const [packageTypeList, setPackageTypeList] = useState([]);
  const [boxesList, setBoxesList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [hsn, setHsn] = useState('');
  const [savedTypedEntries, setSavedTypedEntries] = useState([]);

  


  function handleOnChangenew(event, newValue) {
    // Check if the entered value is not in the provided options
    if (newValue && !Object.values(productList).includes(newValue)) {
      // Handle the custom value here, e.g., add it to a list
      console.log("Custom Value:", newValue);
    }
  }


  const MultipleSearchBoxes = ({ data, index, initialName, initialHsn }) => {
    return (
      <div key={index}>
        <SearchComponent
          data={data}
          initialName={initialName}
          initialHsn={initialHsn}
        />
      </div>

    );
  };

  const SearchComponent = ({ boxInd, itemInd, data, initialName, initialHsn }) => {
    const updatedResponses = [...boxesList];
    const [selectedItem, setSelectedItem] = useState(boxesList[boxInd][0]["items"][itemInd]);

    const handleSelectedItem = (old, value) => {
      console.log("Input selected",value);
      setSelectedItem(value);
      if (value) {
        updatedResponses[boxInd][0]["items"][itemInd]= {...updatedResponses[boxInd][0]["items"][itemInd], ...value}
      } else {
        updatedResponses[boxInd][0]["items"][itemInd]["hsn"]='';
      }
      setHsn(updatedResponses);
    };

    // useEffect(() => {
    //   // Set initial values when they are provided
    //   console.log("Useeffect called -- SearchComponent");
    //   if (initialName) {
    //     const initialItem = data.find((item) => item.name === initialName);
    //     setSelectedItem(initialItem || null);
    //   }
    //   if (initialHsn) {
    //     setHsn(initialHsn);
    //   }
    // }, [data, initialName, initialHsn]);

    return (
      <div>
        <Autocomplete
          disableClearable
          options={data[0]}
          getOptionLabel={(option) => option.name || ''}
          renderInput={(params) => <MDInput {...params} />}
          onChange={handleOnChangenew}
          onInputChange={handleOnChangenew}
          value={selectedItem}
      
          freeSolo 
        />
      </div>
    );
  };


  const handleInputChange = (index, field, value) => {
    const updatedResponses = [...boxesList];
    updatedResponses[index][0][field] = value;
    setBoxesList(updatedResponses);
  };

  const handleQuantityInputChange = (index,itemIndex, value) => {
    const updatedResponses = [...boxesList];
    updatedResponses[index][0]["items"][itemIndex]["quantity"] = value;
    setBoxesList(updatedResponses);
  };

  const handleHSNInputChange = (index,itemIndex, value) => {
    const updatedResponses = [...boxesList];
    updatedResponses[index][0]["items"][itemIndex]["hsn"] = value;
    setBoxesList(updatedResponses);
  };


  const getBoxes = async (boxes) => {
    let temp;
    temp = [];
    try {
      for (let bx of boxes) {
        let a = await getBox(bx);
        temp.push(a.data);
      }
      console.log("partha after execute");
      setBoxesList(temp);
      console.log(boxesList + "martin2");
    }
    catch (err) {
      console.log(err);
    }
  }



  const getProductsList = async () => {
    let temp;
    temp = [];
    try {
      let a = await getProducts();
      console.log("partha after execute");
      setProductList(a);
    }
    catch (err) {
      console.log(err);
    }
  }

  const AutoCompleteField = ({ data }) => {
    const [selectedOption, setSelectedOption] = useState(null);

    return (
      <Autocomplete
        value={selectedOption}
        onChange={(event, newValue) => {
          setSelectedOption(newValue);
        }}
        options={data}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Name"
            variant="outlined"
            fullWidth
          />
        )}
      />
    );
  };

  useEffect(() => {

    getCustomerType()
    getPaymentMode()
    getStatus()
    // props["details"]["boxes"] != [] || props["details"]["boxes"] != null ? getBoxes(props["details"]["boxes"]) : null
    if ((props["details"]["boxes"] != []) && props["details"]["boxes"] != null) {
      getBoxes(props["details"]["boxes"]);
    }
    getCorporateClients()
      .then((resp) => {
        console.log(resp.data);
        setCorporateList([...resp.data])
      })
      .catch((err) => {
        console.log(err);
      });
    getCourierMode()
      .then((resp) => {
        console.log(resp.data);
        updateCourierModeList(resp.data)
      })
      .catch((err) => {
        console.log(err);
      });
    getPackageType()
      .then((resp) => {
        console.log(resp.data);
        setPackageTypeList(resp.data)
      })
      .catch((err) => {
        console.log(err);
      });
    getProductsList()


  }, [setCorporateList, setCourierModeList, setPackageTypeList, setBoxesList, setProductList]);



  const calculateVolume = (length, breadth, height) => {
    const volume = (length * breadth * height) / 5000;
    return volume;
  };

  const corporteClientList = (data) => {
    for (const i = 0; i < data.length; i++) {
      console.log(data[i].name);
    }
  };

  const handleClose = () => {
    props.handleClose();
  };
  const handleCustomerTypeChange = (event) => {
    setCustomerType(event.target.value);
  };

  const handleClientChange = (event) => {
    setClient(event.target.value);
  };
  const handleModeChange = (event) => {
    setMode(event.target.value);
  };


  const handlePaymentModeChange = (event) => {
    setPaymentMode(event.target.value);
  };

  const handleStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleParcelType = (event) => {
    setParcelType(event.target.value);
  };

  const returnDocuments = () => {
    if(props.details.attachments != null && props.details.attachments.length != 0 && props.details.attachments != []){
     return ( <Grid container direction='row' style={{ paddingTop: 20 }} >
    {props.details.attachments.map(data => <div key={data["name"]}
    >
      {returnPngOrFile(data["file"])}

    </div>)}
  </Grid>);
    }
    else{
      return (<div style={{paddingTop:10}}><Grid >
      <MDTypography

        variant="caption"
        fontWeight="bold"
        color="dark"
      >
        No Documents attached
      </MDTypography>

    </Grid></div>);
    }
   
  }
  

  const returnPngOrFile = (filepath) => {
    let extension = filepath.split(".").pop();
    console.log(extension)
    if (extension === "pdf" || extension === "doc" || extension === "docx") {
      return (
        <a href={"http://139.59.62.38:3031/" + filepath} alignItems="center" target="_blank" >
          <Grid item container alignItems="center" direction='column' style={{ paddingRight: 50 }}>

            <MDAvatar bgColor="info" style={{ width: "100px", height: "100px" }} variant="square" >
              <FileOpenIcon fontSize="large" ></FileOpenIcon>

            </MDAvatar>

            <MDTypography
              variant="overline"
              fontWeight="bold"
              color="dark"
            >
              {" "}
              Download{" "}
            </MDTypography>


          </Grid></a>)
    }
    else {
      return (
        <a href={"http://139.59.62.38:3031/" + filepath} alignItems="center" target="_blank" >
          <Grid item container alignItems="center" direction='column' style={{ paddingRight: 50 }}>

            <img width={100} height={100}
              src={filepath}
            />
            <MDTypography

              variant="overline"
              fontWeight="bold"
              color="dark"
            >
              {" "}
              Download{" "}
            </MDTypography>

          </Grid>
        </a>)
    }
  }

  const updateDetails = () => {
    /* let wastage = 0;
    if (closed) {
      wastage = taken - returned;
    }
    let temp = {
      taken: taken,
      returned: returned,
      wastage: wastage,
      raw_material: rawmaterial,
      isClosed: closed,
    };
    updatePeelingEntry(temp, props.details.id)
      .then((resp) => {
        console.log("Updated Entry");
        props.toast(toast_msessages.peelEntryedit_success, "success");
        props.setPeelingTableRef(true);
        handleClose();
      })
      .catch((err) => {
        props.toast(toast_msessages.peelEntryedit_failure, "warning")
        console.log(err);
        handleClose();
      }); */

    console.log("Updated Entry");
    props.toast(toast_msessages.peelEntryedit_success, "success");
/*       handleClose();
 */  };

  const getCustomerType = (event) => {

    if (props.details.pickup_type === 0) {

      setCustomerType(0)
    }

    if (props.details.pickup_type === 1) {

      setCustomerType(1)
    }

    if (props.details.pickup_type === 2) {

      setCustomerType(2)
    }
  };

  const getStatus = (event) => {

    if (props.details.status === 0) {

      setStatus(0)
    }

    if (props.details.status === 1) {

      setStatus(1)
    }

    if (props.details.status === 2) {

      setStatus(2)
    }

    if (props.details.status === 3) {

      setStatus(3)
    }

    if (props.details.status === 4) {

      setStatus(4)
    }


  };

  const getPaymentMode = (event) => {
    console.log("get payment")
    if (props.details.payment_mode === "upi") {
      setPaymentMode(0)
    }

    if (props.details.payment_mode === "neft") {

      setPaymentMode(1)
    }

    if (props.details.payment_mode === "cheque") {

      setPaymentMode(2)
    }

    if (props.details.payment_mode === "online") {

      setPaymentMode(3)
    }
    if (props.details.payment_mode === "cash") {
      console.log("get customer 4")
      setPaymentMode(4)
    }
  };

  const updateCourierModeList = (data) => {
    let temp;
    temp = [];

    data.map((e, index) => {
      console.log(e + "afrid")
      temp.push(e);
    },
    )
    setCourierModeList(temp)


  }



  const getcontents = (boxIndex,items) => {
    console.log(items.length, "shahid length")
    let i = 0
    let temp
    temp = []
    return items.map((it, i) => {
      return <Grid container direction='row' paddingTop={1} paddingLeft={2} xs={12} spacing={3}>
        <Grid item xs={4} >
          {/* <MultipleSearchBoxes data={Object.values(productList)} index={i} initialName={items[i].name} initialHsn={items[i].hsn} /> */}
          <SearchComponent boxInd={boxIndex} itemInd={i} data={Object.values(productList)} initialName={items[i].name} initialHsn={items[i].hsn} setHsn = {setBoxesList} />
          {/* <MDInput type="search" sx={{ width: "85%" }} label="product name" /> */}
        </Grid>
        <Grid item xs={4} >
          <MDInput sx={{ width: "85%" }} value={items[i].hsn} onChange={(e) => handleHSNInputChange(boxIndex,i,e.target.value)} label="hsn code" />
        </Grid>
        <Grid item xs={4} >
          <MDInput sx={{ width: "80%" }} value={items[i].quantity} onChange={(e) => handleQuantityInputChange(boxIndex,i,e.target.value)} label="quantity" />
        </Grid>
      </Grid>
    })

  }

  return (
    <Dialog
      id="modal-display"
      open={open}
      aria-labelledby="form-dialog-title"
      onClose={handleClose}
      fullWidth
      maxWidth="1000px"
    >
      <DialogContent style={{ width: "100%" }}>
        <MDTypography
          className="editpeelmodal-display-text"
          variant="button"
          fontWeight="bold"
          color="dark"
        >
          {" "}
          Parcel Details - {props.details.code}
        </MDTypography>

        <Grid container direction='row' spacing={3} paddingTop={3} paddingBottom={5}>
          <Grid item xs={6}>
            <MDTypography
              // className="product-name"
              variant="inherit"
              fontWeight="bold"
              color="dark"
            >
              {" "}
              Sender{" "}
            </MDTypography>
            <div style={{ padding: "5px" }}>
            </div>
            <Card variant="outlined" sx={{
              boxShadow: 2,
            }}>
              <CardContent>
                <div>
                  <MDTypography
                    // className="product-name"
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Name{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  value={fromName}
                  onChange={(text) => {
                    setFromName(text.target.value);
                  }} />
                <div>
                  <MDTypography
                    // className="product-name"
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Address{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  multiline rows={8}
                  value={fromAddress}
                  onChange={(text) => {
                    setFromAddress(text.target.value);
                  }} />
                <div>
                  <MDTypography
                    // className="product-name" 
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Phone Number{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  value={fromNumber}
                  onChange={(text) => {
                    setFromNumber(text.target.value);
                  }} />
                <div>
                  <MDTypography
                    // className="product-name"
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Email{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  value={fromEmail === "" ? "N/A" : fromEmail}
                  onChange={(text) => {
                    setFromEmail(text.target.value);
                  }} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} >
            <MDTypography
              // className="product-name"
              variant="inherit"
              fontWeight="bold"
              color="dark"

            >
              {" "}
              Receiver{" "}
            </MDTypography>
            <div style={{ padding: "5px" }}>
            </div>
            <Card variant="outlined" sx={{
              boxShadow: 2,
            }}>
              <CardContent>
                <div>
                  <MDTypography
                    // className="product-name"
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Name{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  value={receiverName}
                  onChange={(text) => {
                    setreceiverName(text.target.value);
                  }} />
                <div>
                  <MDTypography
                    // className="product-name"
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Address{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  multiline rows={8}
                  value={receiverAddress}
                  onChange={(text) => {
                    setreceiverAddress(text.target.value);
                  }} />

                <div>
                  <MDTypography
                    // className="product-name" 
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Phone Number{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  value={receiverNumber}
                  onChange={(text) => {
                    setreceiverNumber(text.target.value);
                  }} />
                <div>
                  <MDTypography
                    // className="product-name"
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Email{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  value={receiverEmail === "" ? "N/A" : receiverEmail}
                  onChange={(text) => {
                    setreceiverEmail(text.target.value);
                  }} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Card variant="outlined" sx={{
          boxShadow: 2,
        }}>

          <CardContent>
            <Grid container direction='row' paddingTop={1} paddingLeft={2} xs={12}>
              <Grid item xs={6} >
                <Grid container direction='column' spacing={1.5} >
                  <Grid item>
                    <MDTypography
                      // className="note-textarea"
                      variant="inherit"
                      fontWeight="bold"
                      color="dark"
                    >
                      {" "}
                      Customer Type{" "}
                    </MDTypography>
                  </Grid>

                  <Grid item>
                    <FormControl sx={{ m: 0, minWidth: 450, }}>
                      <Select
                        defaultValue=""
                        style={{ height: 50, paddingRight: 10 }}
                        value={customerType}
                        onChange={handleCustomerTypeChange}
                        displayEmpty
                        IconComponent={() => { return (<ArrowDropDown />) }}
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={0}>Pickup</MenuItem>
                        <MenuItem value={1}>Walk-in</MenuItem>
                        <MenuItem value={2}>Corporate</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                </Grid>
              </Grid>
              <Grid item xs={6} >

                {customerType === 2 ? <Grid container direction='column' spacing={1.5} >
                  <Grid item>
                    <MDTypography
                      // className="note-textarea"
                      variant="inherit"
                      fontWeight="bold"
                      color="dark"
                    >
                      {" "}
                      Client{" "}
                    </MDTypography>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ m: 0, minWidth: 450, }}>

                      <Select

                        style={{ height: 50, paddingRight: 5 }}
                        value={client}
                        onChange={handleClientChange}
                        displayEmpty
                        IconComponent={() => { return (<ArrowDropDown />) }}

                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        {corporateList.map((item, index) => (
                          <MenuItem value={item._id}>{item.name}</MenuItem>
                        ))}

                      </Select>
                    </FormControl>
                  </Grid>

                </Grid> : <Grid></Grid>}
              </Grid>
            </Grid>
            <Grid container direction='row' paddingTop={5} paddingLeft={2} xs={12} >
              <Grid item xs={6} >
                <Grid container direction='column' spacing={1.5} >
                  <Grid item>
                    <MDTypography
                      // className="note-textarea"
                      variant="inherit"
                      fontWeight="bold"
                      color="dark"
                    >
                      {" "}
                      Courier{" "}
                    </MDTypography>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ m: 0, minWidth: 450, }}>
                      <Select
                        defaultValue=""
                        style={{ height: 50, paddingRight: 5 }}
                        value={mode}
                        IconComponent={() => { return (<ArrowDropDown />) }}
                        onChange={handleModeChange}
                        displayEmpty

                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        {couriermodeList.map((item, index) => (
                          <MenuItem value={item._id}>{item.name}</MenuItem>
                        ))}

                      </Select>
                    </FormControl>
                  </Grid>

                </Grid>
              </Grid>
              <Grid item xs={6} >

                {/* {mode===3?<Grid container direction='column' spacing={1.5} >
                  <Grid item>
                    <MDTypography
                      // className="note-textarea"
                      variant="inherit"
                      fontWeight="bold"
                      color="dark"
                    >
                      {" "}
                      Other mode{" "}
                    </MDTypography>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ m: 0, minWidth: 450, }}>
                      <Select
                        defaultValue=""
                        style={{ height: 50 }}
                        value={otherMode}
                        onChange={handleOtherModeChange}
                        displayEmpty

                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        {otherModeList.map((item, index) => (
                              <MenuItem value={item._id}>{item.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                </Grid>:<Grid></Grid>} */}
              </Grid>
              <Grid item container direction='column' spacing={1.5} paddingTop={5} >
                <Grid item>
                  <MDTypography
                    // className="note-textarea"
                    variant="inherit"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Parcel Type{" "}
                  </MDTypography>
                </Grid>
                <Grid item>
                  <FormControl sx={{ m: 0, minWidth: 450, }}>
                    <Select
                      defaultValue=""
                      style={{ height: 50, paddingRight: 5 }}
                      value={parcelType}
                      IconComponent={() => { return (<ArrowDropDown />) }}
                      onChange={handleParcelType}
                      displayEmpty

                      inputProps={{ 'aria-label': 'Without label' }}
                    >

                      {packageTypeList.map((item, index) => (
                        <MenuItem value={item._id}>{item.name}</MenuItem>
                      ))}

                    </Select>
                  </FormControl>
                </Grid>

              </Grid>
            </Grid>
          </CardContent> </Card>



        <Grid container direction='column' paddingTop={5} xs={12} >

          <Grid item fullWidth>
            <Card variant="outlined" sx={{
              boxShadow: 2,
              width: "100%"
            }}>
              <CardContent>
                <MDTypography
                  // className="note-textarea"
                  variant="inherit"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Documents Uploaded{" "}
                </MDTypography>

              
               {returnDocuments()}

              


              </CardContent></Card>

          </Grid>


        </Grid>

        <Grid container direction='column' xs={12} paddingTop={5} paddingBottom={5} >
          <div style={{ padding: "5px" }}>
          </div>
          <Card variant="outlined" sx={{
            boxShadow: 2,
          }}>
            <CardContent>
              <div>
                <MDTypography
                  // className="product-name"
                  variant="button"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Total Weight(kg){" "}
                </MDTypography>
              </div>
              <MDInput sx={{ width: "100%" }}
                value={totalWeight}
                onChange={(text) => {
                  setTotalWeight(text.target.value);
                }} />
              <div>
                <MDTypography
                  // className="product-name"
                  variant="button"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Courier Amount{" "}
                </MDTypography>
              </div>
              <MDInput sx={{ width: "100%" }}
                value={courierAmount}
                onChange={(text) => {
                  setCourierAmount(text.target.value);
                }} />
              <div>
                <MDTypography
                  // className="product-name" 
                  variant="button"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Other Amount{" "}
                </MDTypography>
              </div>
              <MDInput sx={{ width: "100%" }}
                value={otherAmount}
                onChange={(text) => {
                  setOtherAmount(text.target.value);
                }} />
              <div>
                <MDTypography
                  // className="product-name"
                  variant="button"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Total Amount{" "}
                </MDTypography>
              </div>
              <MDInput sx={{ width: "100%" }}
                value={totalAmount}
                onChange={(text) => {
                  setTotalAmount(text.target.value);
                }} />

              <div>
                <MDTypography
                  // className="product-name"
                  variant="button"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Payment Mode{" "}
                </MDTypography>
              </div>
              <div>
                <FormControl sx={{ m: 0, minWidth: 450, }}>
                  <Select
                    style={{ height: 50, paddingRight: 5 }}
                    value={paymentMode}
                    IconComponent={() => { return (<ArrowDropDown />) }}
                    onChange={handlePaymentModeChange}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >

                    <MenuItem value={0}>Gpay/Phonepe/UPI</MenuItem>
                    <MenuItem value={1}>Bank Transfer</MenuItem>
                    <MenuItem value={2}>Cheque</MenuItem>
                    <MenuItem value={3}>Online</MenuItem>
                    <MenuItem value={4}>Cash</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div>
                <MDTypography
                  // className="product-name" 
                  variant="button"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Managed By{" "}
                </MDTypography>
              </div>
              <MDInput sx={{ width: "100%" }}
                value={managedBy}
                onChange={(text) => {
                  setManagedBy(text.target.value);
                }} />

              <div>
                <MDTypography
                  // className="product-name" 
                  variant="button"
                  fontWeight="bold"
                  color="dark"
                >
                  {" "}
                  Note{" "}
                </MDTypography>
              </div>
              <MDInput sx={{ width: "100%" }}
                multiline rows={5}
                value={note}
                onChange={(text) => {
                  setNote(text.target.value);
                }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid>
          {boxesList.map((response, boxIndex) => (
            console.log(JSON.stringify(response) + "boxes count shahid"),
            <div style={{ paddingTop: 10 }}>
              <Card variant="outlined" sx={{
                boxShadow: 2,
              }}>
                <CardContent>
                  <MDTypography
                    // className="note-textarea"
                    variant="heading3"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Box {boxIndex + 1}{" "}
                  </MDTypography>
                  <Grid container direction='row' paddingTop={1} paddingLeft={2} xs={12} >
                    <Grid item xs={6} >
                      <Grid container direction='column' spacing={1.5} >
                        <Grid item>
                          <MDTypography
                            // className="note-textarea"
                            variant="inherit"
                            fontWeight="bold"
                            color="dark"
                          >
                            {" "}
                            Length{" "}
                          </MDTypography>
                        </Grid>
                        <Grid item>
                          <MDInput sx={{ width: "90%" }}
                            value={response[0].length}
                            onChange={(e) => handleInputChange(boxIndex, 'length', e.target.value)} />
                        </Grid>

                      </Grid>
                    </Grid>
                    <Grid item xs={6} >

                      <Grid container direction='column' spacing={1.5} >
                        <Grid item>
                          <MDTypography
                            // className="note-textarea"
                            variant="inherit"
                            fontWeight="bold"
                            color="dark"
                          >
                            {" "}
                            Breadth{" "}
                          </MDTypography>
                        </Grid>
                        <Grid item>
                          <MDInput sx={{ width: "90%" }}
                            value={response[0].breadth}
                            onChange={(e) => handleInputChange(boxIndex, 'breadth', e.target.value)} />
                        </Grid>

                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container direction='row' paddingTop={5} paddingLeft={2} xs={12} >
                    <Grid item xs={6} >
                      <Grid container direction='column' spacing={1.5} >
                        <Grid item>
                          <MDTypography
                            // className="note-textarea"
                            variant="inherit"
                            fontWeight="bold"
                            color="dark"
                          >
                            {" "}
                            Height{" "}
                          </MDTypography>
                        </Grid>
                        <Grid item>
                          <MDInput sx={{ width: "90%" }}
                            value={response[0].height}
                            onChange={(e) => handleInputChange(boxIndex, 'height', e.target.value)} />
                        </Grid>

                      </Grid>
                    </Grid>
                    <Grid item xs={6} >

                      <Grid container direction='column' spacing={1.5} >
                        <Grid item>
                          <MDTypography
                            // className="note-textarea"
                            variant="inherit"
                            fontWeight="bold"
                            color="dark"
                          >
                            {" "}
                            Weight{" "}
                          </MDTypography>
                        </Grid>
                        <Grid item>
                          <MDInput sx={{ width: "90%" }}
                            value={response[0].weight}
                            onChange={(e) => handleInputChange(boxIndex, 'weight', e.target.value)} />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item container direction='column' spacing={1.5} paddingTop={5} >
                      <Grid item>
                        <MDTypography
                          // className="note-textarea"
                          variant="inherit"
                          fontWeight="bold"
                          color="dark"
                        >
                          {" "}
                          Volumetric weight{" "}
                        </MDTypography>
                      </Grid>
                      <Grid item>
                        <MDInput sx={{ width: "35%" }}
                          value={calculateVolume(response[0].length, response[0].breadth, response[0].height)}
                          onChange={(text) => {

                          }} />
                      </Grid>

                    </Grid>
                  </Grid>
                  <MDTypography style={{ paddingLeft: 20, paddingTop: 20 }}
                    // className="note-textarea"
                    variant="inherit"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Box contents{" "}
                  </MDTypography>
                  {getcontents(boxIndex,response[0].items)}

                </CardContent> </Card>
            </div>
          ))}


          <Grid style={{ paddingTop: "20px", paddingBottom: "30px" }} xs={12} fullWidth>
            <Card variant="outlined" sx={{
              boxShadow: 2,
              width: "100%"
            }}>
              <CardContent>
                <Grid container direction="column">
                  <Grid item>
                    <MDTypography
                      // className="product-name" 
                      variant="button"
                      fontWeight="bold"
                      color="dark"
                    >
                      {" "}
                      Parcel Status{" "}
                    </MDTypography>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ m: 0, minWidth: 450, }}>
                      <Select
                        defaultValue=""
                        IconComponent={() => { return (<ArrowDropDown />) }}
                        style={{ height: 50, paddingRight: 5 }}
                        value={status}
                        onChange={handleStatus}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={0}>Picked up</MenuItem>
                        <MenuItem value={1}>In-transit</MenuItem>
                        <MenuItem value={2}>Delivered</MenuItem>
                        <MenuItem value={3}>On-hold</MenuItem>
                        <MenuItem value={4}>Pending</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {status == 3 || status == 4 ? <Grid>
                  <div style={{ paddingTop: 10 }}>
                    <MDTypography
                      // className="product-name" 
                      variant="button"
                      fontWeight="bold"
                      color="dark"
                    >
                      {" "}
                      Reason{" "}
                    </MDTypography>
                  </div>
                  <MDInput sx={{ width: "100%" }}
                    value={reason}
                    multiline rows={5}
                    onChange={(text) => {
                      setReason(text.target.value);
                    }} />
                </Grid> : <div></div>}


                <div style={{ paddingTop: 10 }}>
                  <MDTypography
                    // className="product-name" 
                    variant="button"
                    fontWeight="bold"
                    color="dark"
                  >
                    {" "}
                    Tracking Number{" "}
                  </MDTypography>
                </div>
                <MDInput sx={{ width: "100%" }}
                  value={trackingNumber}
                  onChange={(text) => {
                    setTrackingNumber(text.target.value);
                  }} />


              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container
          direction="row"
          justifyContent="flex-end"
          spacing={1}
          alignItems="flex-end"
          style={{ paddingTop: 20 }}>
          <Grid item>
            <MDButton
              onClick={() => {
                handleClose();
              }}
              variant="outlined"
              color="secondary"
              size="medium"
            >
              Cancel
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              onClick={() => {
                updateDetails();
              }}
              variant="gradient"
              color="primary"
              size="medium"
            >
              &nbsp;Save&nbsp;
            </MDButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog >
  );
}

export default EditDBModal;
